type SchemaDefinition = Record<string, string>;
export const SCHEMAS: Record<string, SchemaDefinition> = {
  v2: {
    checkpoint: 'id, syncStatus',
    checkpointResults: 'id, checkpoint, student, position, syncStatus',
    checkpointAssessments: 'id, checkpoint, grade_subject, syncStatus',
    studentsDataV2:
      '++id, schoolClass, admissionNumber, user , uuid, isNewCreated, syncStatus, username, status, session',
    studentsAssessmentData: 'id,student, syncStatus',
    usersDataV2: '++id, username, uuid, isNewCreated, syncStatus',
    checkedStudentExam:
      'id, studentName, totalMarks, checkpoint, obtainedMarks, gradeSubject, schoolClass, syncStatus, studentProfile',
    studentDuplicate:
      'admissionNumber, uuid, name, schoolClass, verificationStatus',
    studentSubjectAnswerAnalysis: 'id, syncStatus',
  },
};
SCHEMAS.v3 = {
  ...SCHEMAS.v2,
  checkedStudentExamV2:
    'uuid,id, studentName, checkpoint, gradeSubject, schoolClass, syncStatus, studentProfile',
};
